module.exports = __webpack_public_path__ + "static/media/16a-02_ST-2016-2032x3175mm-oleo-sobre-madera.c6220c2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/16a/16a-02_ST-2016-2032x3175mm-oleo-sobre-madera.jpg
// module id = 184
// module chunks = 0